import { Component, OnInit } from '@angular/core';
import { FormBuilder,Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationStart, Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { filter } from 'rxjs/operators';
import { Globals } from 'src/app/globals';
import { ProductoService } from 'src/app/servicios/producto.service';
import { ModalProductoDetalleComponent } from '../modal-producto-detalle/modal-producto-detalle.component';

@Component({
  selector: 'app-vista-producto',
  templateUrl: './vista-producto.component.html',
  styleUrls: ['./vista-producto.component.scss']
})
export class VistaProductoComponent implements OnInit {
  producto = {
    cantidad:null,
    stockid:null,
    precio_final_con_impuesto:null,
    tags:[],
    detalle:"",
    description:null,
    cargando: false,
    imagenes:[],
    data:{
      stockid: "",
      precio_final_con_impuesto: 0,
      detalle:"",
      tags:[]
    },
    total : "0.00"
  }
  constructor(
		private fb: FormBuilder,
		private productoService: ProductoService,
		// private snackBar: MdcSnackbar,
		private router: Router,
		// public dialogRef: MatDialogRef<ModalProductoDetalleComponent>,
		public globals: Globals,
    // private snackBar: MatSnackBar
  ) {
    // console.log('Producto',this.producto);
    this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        if (event.navigationTrigger === 'popstate') {
          // El usuario intentó usar el botón de atrás
          // Aquí puedes decidir qué hacer, como mostrar un diálogo, redirigir, etc.
          localStorage.setItem('descripcion',this.producto.description)
          localStorage.setItem('despues_de_agregar','true')
          this.globals.configuracion.modalproducto = null;
        // window.history.back();
        }
      });
  }


	formComportamiento = {
		enviando: false
	};

	form = this.fb.group({
		stockid:[
			this.producto.stockid,
			[
				Validators.required
			]
		],
		cantidad:[
			1,
			[
				Validators.required
			]
		]
	});

  formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  inputEvent( cantidad ){
    this.producto.total = this.formatter.format( this.producto.precio_final_con_impuesto * parseFloat( cantidad ) );
  }

  incrementarCantidad(){
    let valor = parseInt(this.form.controls.cantidad.value);
    this.form.controls.cantidad.setValue( ++valor );
    this.producto.total = this.formatter.format( this.producto.precio_final_con_impuesto * valor );
  }

  disminuirCantidad(){
    let valor = parseInt(this.form.controls.cantidad.value);
    if( valor > 1 ){
      this.form.controls.cantidad.setValue( --valor );
      this.producto.total = this.formatter.format( this.producto.precio_final_con_impuesto * valor );
    }
  }

  customOptions: OwlOptions = {
		items: 1,
		margin: 10,
		autoHeight: true,
		loop: false,
		mouseDrag: true,
		touchDrag: true,
		pullDrag: true,
		dots: true,
		navSpeed: 700,
		navText: ['', ''],
		nav: false,
    //lazyLoad: true
  }

  detalleProducto(){
     /*
    this.producto.cargando = true;

    this.productoService.productoDetalle({
      stockid: this.stockid
    }).subscribe(
      resultado =>{
        if( !resultado.error ){
          this.producto.data = resultado.producto;

          this.producto.total = this.formatter.format( resultado.producto.precio_final_con_impuesto * parseFloat( this.form.controls.cantidad.value ) );
        }else{
          //console.log("Error",resultado.mensaje);
        
        }

        this.producto.cargando = false;
      },
      error =>{
        //console.log("Error",error);
       
        
        this.producto.cargando = false;
      }
    )
    */
    // this.producto.data = this.producto;
    // console.log('this.producto ?',this.producto)
    this.producto.detalle = this.producto.detalle.replace(/\n/g, '<br>');
    this.producto.total = this.formatter.format( this.producto.precio_final_con_impuesto * parseFloat( this.form.controls.cantidad.value ) );
  }
  seCerro() {
    // console.log('this.producto ? se cerro',this.producto)
   
    localStorage.setItem('descripcion',this.producto.description)
    localStorage.setItem('despues_de_agregar','true')
    this.globals.configuracion.modalproducto = null;
    window.history.back();
  }
  agregarProducto( cotizar = false ){
    this.formComportamiento.enviando = true;

    this.productoService.productoAgregarAlCarro({
      stockid: this.producto.stockid,
      cantidad: this.form.controls.cantidad.value,
      typeabbrev: this.globals.configuracion.front.typeabbrev
    }).subscribe(
      resultado =>{
        if( !resultado.error ){
          this.globals.setDataToken( resultado.dataToken );

          /*
          var total = 0;
          for( let x = 0; x < resultado.dataToken.app.cart.productos.length; x++ ){
            total += resultado.dataToken.app.cart.productos[x].precio_final_con_impuesto * resultado.dataToken.app.cart.productos[x].cantidad;
          }

          this.globals.configuracion.front.cart.productos = resultado.dataToken.app.cart.productos;
          this.globals.configuracion.front.cart.total = this.formatter.format( total );
          this.globals.setDataFront();
          */

          let indexProduct = this.globals.configuracion.front.cart.productos.find( element => element.stockid == this.producto.stockid );
          if( indexProduct !== undefined ){
            //let cantidad = indexProduct.cantidad;
            //indexProduct = this.producto;
            indexProduct.cantidad += parseFloat( this.form.controls.cantidad.value );
          }else{
            this.producto.cantidad = parseFloat( this.form.controls.cantidad.value );
            this.globals.configuracion.front.cart.productos.push( this.producto );
          }

          var total = 0;
          for( let x = 0; x < this.globals.configuracion.front.cart.productos.length; x++ ){
            total += this.globals.configuracion.front.cart.productos[x].precio_final_con_impuesto * this.globals.configuracion.front.cart.productos[x].cantidad;
          }
          
          this.globals.configuracion.front.cart.total = this.formatter.format( total );

          this.globals.setDataFront();
          // console.log('this.producto',this.producto)
          if(localStorage.getItem('paginaActual') != null){

            let pagina_actual = parseInt(localStorage.getItem('paginaActual'));
            localStorage.setItem('paginaActual', pagina_actual.toString())
          }
          localStorage.setItem('descripcion',this.producto.description)
          localStorage.setItem('despues_de_agregar','true')
          window.history.back();
          

          if( cotizar ){
            this.router.navigate(['/cotizar']);
          }
          // this.dialogRef.close();
        }else{
          //console.log("Error",resultado.mensaje);
        
        }

        this.formComportamiento.enviando = false;
      },
      error =>{
        //console.log("Error",error);
        

        this.formComportamiento.enviando = false;
      }
    )
  }

  agregarProductoCotizar(){
    this.agregarProducto( true );
  }
  ngOnInit(): void {
	  this.producto = JSON.parse(localStorage.getItem('producto'));

    this.detalleProducto();
    window.scrollTo(0, 0);
  }

}
